import mitt from "mitt";

type Events = {
  "explainModal:show": { message: any };
  "inquiryModal:show": { type?: "success" | "error" };
  "completeModal:show": { type?: "success" | "error" };
  "pdfImageModal:show": { images: any };
  "channelPreviewModal:show": { channel: any };
};

const eventBus = mitt<Events>();

export default eventBus;
